module.exports = {
}


// WEBPACK FOOTER //
// ./src/i18n/locale.en.js